import { Link } from "react-router-dom";
import { CalendarDays, CreditCard, FileText, MessageSquare } from "lucide-react";
import { PortalHeading } from "./PortalLayout";
import { JobTimeline } from "@/components/shared/JobTimeline";
import { useAuth } from "@/context/AuthContext";
import { useFetch } from "@/hooks/useFetch";
import { money } from "@/lib/api";

const Stat = ({ icon: Icon, label, value, to, testId }) => (
  <Link to={to} data-testid={testId} className="rounded-2xl bg-white p-5 hover:-translate-y-0.5 hover:shadow-lg transition-[transform,box-shadow]">
    <Icon className="h-5 w-5 text-[#F86900]" /><p className="mt-3 font-display text-2xl font-extrabold">{value}</p><p className="text-xs text-[#56585E]">{label}</p>
  </Link>
);

export default function Dashboard() {
  const { user } = useAuth();
  const { data } = useFetch("/portal/dashboard");
  if (!data) return null;
  const owed = data.unpaid_invoices.reduce((a, i) => a + Number(i.balance || 0), 0);
  return (
    <div data-testid="portal-dashboard">
      <PortalHeading title={`Hello, ${(user?.name || "there").split(" ")[0]}`} sub="Everything happening with your vehicles at Accelary." />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <Stat icon={FileText} label="Quotes awaiting you" value={data.pending_quotes} to="/portal/quotes" testId="dashboard-stat-quotes" />
        <Stat icon={CalendarDays} label="Next booking" value={data.next_booking ? data.next_booking.scheduled_date : "None"} to="/portal/bookings" testId="dashboard-stat-booking" />
        <Stat icon={CreditCard} label="Outstanding balance" value={money(owed)} to="/portal/billing" testId="dashboard-stat-balance" />
        <Stat icon={MessageSquare} label="Unread messages" value={data.unread_messages} to="/portal/messages" testId="dashboard-stat-messages" />
      </div>
      <section className="mt-6 rounded-2xl bg-white p-6" data-testid="dashboard-active-job">
        <div className="flex items-center justify-between mb-5"><h2 className="font-display font-bold text-lg">Active job</h2>{data.active_job && <Link to="/portal/jobs" className="text-sm font-semibold text-[#020165] underline">Details</Link>}</div>
        {data.active_job ? (
          <><p className="text-sm text-[#56585E] mb-4">{data.active_job.reference} · {data.active_job.service_title}</p><JobTimeline job={data.active_job} /></>
        ) : <p className="text-sm text-[#56585E]">No vehicle in the workshop right now. <Link to="/book" className="underline">Book a service</Link></p>}
      </section>
    </div>
  );
}
